import { render, staticRenderFns } from "./StudyRightsStep.vue?vue&type=template&id=69da52f2"
import script from "./StudyRightsStep.vue?vue&type=script&lang=js"
export * from "./StudyRightsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports